import { create } from "zustand";
import { IStore } from "../types/IStore";

const useStore = create<IStore>((set) => ({
  dataReadyTutorial: true,
  setDataReadyTutorial: (v: boolean) => set({ dataReadyTutorial: v }),
}));

export default useStore;
